import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';

// Return true if Common Collections is enabled for the current sport & user
export const useEnableCommonCollections = () => {
  const { currentUser } = useCurrentUserContext();
  const { sport } = useSportContext();
  return (
    sport === Sport.FOOTBALL && !!currentUser?.betaTesterFootballCommonCardsGame
  );
};
